export default class MenuItem {
  constructor(item) {
    Object.assign(this, item)
  }

  get id() {
    return this.label.toLowerCase().replace(/\s/g, '-')
  }
}
